export /* ─── District Data ─────────────────────────────────────── */
const DISTRICTS = [
  {
    n: "Kamrup",
    avail: 92,
    expSkus: 12,
    expQty: 2400,
    expValue: 185000,
    stockout: 8,
    expired: 3,
    pipeline: 88,
  },
  {
    n: "Kamrup M",
    avail: 97,
    expSkus: 4,
    expQty: 800,
    expValue: 62000,
    stockout: 3,
    expired: 1,
    pipeline: 95,
  },
  {
    n: "Dibrugarh",
    avail: 88,
    expSkus: 9,
    expQty: 3100,
    expValue: 240000,
    stockout: 12,
    expired: 4,
    pipeline: 80,
  },
  {
    n: "Jorhat",
    avail: 95,
    expSkus: 3,
    expQty: 500,
    expValue: 38500,
    stockout: 5,
    expired: 1,
    pipeline: 92,
  },
  {
    n: "Nagaon",
    avail: 75,
    expSkus: 8,
    expQty: 1200,
    expValue: 92000,
    stockout: 25,
    expired: 6,
    pipeline: 60,
  },
  {
    n: "Sonitpur",
    avail: 100,
    expSkus: 1,
    expQty: 150,
    expValue: 11500,
    stockout: 0,
    expired: 0,
    pipeline: 100,
  },
  {
    n: "Goalpara",
    avail: 68,
    expSkus: 7,
    expQty: 850,
    expValue: 65000,
    stockout: 32,
    expired: 8,
    pipeline: 45,
  },
  {
    n: "Cachar",
    avail: 82,
    expSkus: 5,
    expQty: 700,
    expValue: 54000,
    stockout: 18,
    expired: 3,
    pipeline: 70,
  },
  {
    n: "Lakhimpur",
    avail: 90,
    expSkus: 4,
    expQty: 600,
    expValue: 46000,
    stockout: 10,
    expired: 2,
    pipeline: 84,
  },
  {
    n: "Dhemaji",
    avail: 78,
    expSkus: 6,
    expQty: 900,
    expValue: 69000,
    stockout: 22,
    expired: 5,
    pipeline: 58,
  },
  {
    n: "Tinsukia",
    avail: 85,
    expSkus: 5,
    expQty: 750,
    expValue: 58000,
    stockout: 15,
    expired: 3,
    pipeline: 72,
  },
  {
    n: "Sibsagar",
    avail: 91,
    expSkus: 3,
    expQty: 400,
    expValue: 31000,
    stockout: 9,
    expired: 1,
    pipeline: 86,
  },
  {
    n: "Golaghat",
    avail: 73,
    expSkus: 7,
    expQty: 1100,
    expValue: 85000,
    stockout: 27,
    expired: 5,
    pipeline: 52,
  },
  {
    n: "Darrang",
    avail: 65,
    expSkus: 10,
    expQty: 1500,
    expValue: 115000,
    stockout: 35,
    expired: 9,
    pipeline: 38,
  },
  {
    n: "Barpeta",
    avail: 80,
    expSkus: 5,
    expQty: 2000,
    expValue: 154000,
    stockout: 20,
    expired: 4,
    pipeline: 68,
  },
  {
    n: "Nalbari",
    avail: 88,
    expSkus: 4,
    expQty: 600,
    expValue: 46000,
    stockout: 12,
    expired: 2,
    pipeline: 78,
  },
  {
    n: "Hailakandi",
    avail: 58,
    expSkus: 13,
    expQty: 1800,
    expValue: 139000,
    stockout: 42,
    expired: 11,
    pipeline: 30,
  },
  {
    n: "Karimganj",
    avail: 72,
    expSkus: 8,
    expQty: 1000,
    expValue: 77000,
    stockout: 28,
    expired: 6,
    pipeline: 48,
  },
  {
    n: "Dhubri",
    avail: 60,
    expSkus: 11,
    expQty: 1600,
    expValue: 123000,
    stockout: 40,
    expired: 10,
    pipeline: 32,
  },
  {
    n: "Kokrajhar",
    avail: 84,
    expSkus: 5,
    expQty: 700,
    expValue: 54000,
    stockout: 16,
    expired: 3,
    pipeline: 74,
  },
  {
    n: "Chirang",
    avail: 70,
    expSkus: 7,
    expQty: 950,
    expValue: 73000,
    stockout: 30,
    expired: 6,
    pipeline: 50,
  },
  {
    n: "Baksa",
    avail: 76,
    expSkus: 6,
    expQty: 800,
    expValue: 62000,
    stockout: 24,
    expired: 5,
    pipeline: 56,
  },
  {
    n: "Udalguri",
    avail: 83,
    expSkus: 5,
    expQty: 650,
    expValue: 50000,
    stockout: 17,
    expired: 3,
    pipeline: 72,
  },
  {
    n: "Biswanath",
    avail: 89,
    expSkus: 3,
    expQty: 450,
    expValue: 35000,
    stockout: 11,
    expired: 2,
    pipeline: 82,
  },
  {
    n: "Charaideo",
    avail: 94,
    expSkus: 2,
    expQty: 300,
    expValue: 23000,
    stockout: 6,
    expired: 1,
    pipeline: 90,
  },
  {
    n: "Hojai",
    avail: 77,
    expSkus: 6,
    expQty: 900,
    expValue: 65000,
    stockout: 23,
    expired: 5,
    pipeline: 55,
  },
  {
    n: "W Karbi A",
    avail: 55,
    expSkus: 14,
    expQty: 2100,
    expValue: 162000,
    stockout: 45,
    expired: 12,
    pipeline: 25,
  },
  {
    n: "Karbi A",
    avail: 62,
    expSkus: 12,
    expQty: 1700,
    expValue: 131000,
    stockout: 38,
    expired: 9,
    pipeline: 35,
  },
  {
    n: "Dima Hasao",
    avail: 68,
    expSkus: 9,
    expQty: 1200,
    expValue: 92000,
    stockout: 32,
    expired: 7,
    pipeline: 42,
  },
  {
    n: "Bajali",
    avail: 86,
    expSkus: 4,
    expQty: 550,
    expValue: 42000,
    stockout: 14,
    expired: 2,
    pipeline: 76,
  },
  {
    n: "Tamulpur",
    avail: 79,
    expSkus: 6,
    expQty: 800,
    expValue: 62000,
    stockout: 21,
    expired: 5,
    pipeline: 60,
  },
  {
    n: "Majuli",
    avail: 91,
    expSkus: 3,
    expQty: 400,
    expValue: 31000,
    stockout: 9,
    expired: 1,
    pipeline: 85,
  },
  {
    n: "S Salmara",
    avail: 66,
    expSkus: 11,
    expQty: 1400,
    expValue: 108000,
    stockout: 34,
    expired: 8,
    pipeline: 40,
  },
];

export /* ─── Facility Bars helper ──────────────────────────────── */
const FACILITIES = [
  {
    name: "Med. College",
    avail: 100,
    expiry: 2,
    expiryQty: 320,
    expiryValue: 15400,
    expired: 0,
    color: "#16a34a",
  },
  {
    name: "District Hosp.",
    avail: 100,
    expiry: 4,
    expiryQty: 580,
    expiryValue: 30800,
    expired: 1,
    color: "#22c55e",
  },
  {
    name: "SDH / CHC",
    avail: 88,
    expiry: 8,
    expiryQty: 1240,
    expiryValue: 61600,
    expired: 3,
    color: "#86efac",
    tc: "#166534",
  },
  {
    name: "PHC",
    avail: 70,
    expiry: 18,
    expiryQty: 2850,
    expiryValue: 139000,
    expired: 6,
    color: "#f59e0b",
  },
  {
    name: "Sub-centre",
    avail: 55,
    expiry: 18,
    expiryQty: 2640,
    expiryValue: 139000,
    expired: 8,
    color: "#ef4444",
  },
];

/* ─── Tab 3: Facility Type Wise Stockout ────────────────── */
export const FACILITY_TYPE_STOCKOUT = [
  { type: "Sub Centre (SC)", stockout: 38, total: 680 },
  { type: "Primary Health Centre (PHC)", stockout: 25, total: 420 },
  { type: "Community Health Centre (CHC)", stockout: 18, total: 210 },
  { type: "Sub-Divisional Hospital (SDH)", stockout: 12, total: 95 },
  { type: "District Hospital (DH)", stockout: 8, total: 33 },
  { type: "Medical College Hospital", stockout: 5, total: 12 },
  { type: "Urban PHC (UPHC)", stockout: 22, total: 180 },
  { type: "Health & Wellness Centre (HWC)", stockout: 30, total: 350 },
  { type: "State Warehouse", stockout: 3, total: 8 },
  { type: "Drug Store / Depot", stockout: 15, total: 45 },
];

export const CATEGORIES = [
  { cat: "Essential Medicines", avail: 88 },
  { cat: "Vaccines & Biologicals", avail: 95 },
  { cat: "Reproductive Health", avail: 82 },
  { cat: "TB / Leprosy", avail: 91 },
  { cat: "Malaria / Vector Control", avail: 74 },
  { cat: "Pediatric Medicines", avail: 86 },
  { cat: "ORS / Zinc / Vit-A", avail: 78 },
  { cat: "Family Planning", avail: 69 },
  { cat: "AYUSH / Herbal", avail: 61 },
  { cat: "Surgical / Consumables", avail: 93 },
];

export const PRODUCTS = [
  { name: "Azithromycin 500mg", fac: 80, cat: "Antibiotic" },
  { name: "Metformin 500mg", fac: 74, cat: "Antidiabetic" },
  { name: "Amlodipine 5mg", fac: 68, cat: "Antihypertensive" },
  { name: "Atenolol 50mg", fac: 61, cat: "Antihypertensive" },
  { name: "Paracetamol 500mg", fac: 57, cat: "Analgesic" },
  { name: "Amoxicillin 500mg", fac: 52, cat: "Antibiotic" },
  { name: "Omeprazole 20mg", fac: 48, cat: "GI" },
  { name: "Salbutamol Inhaler", fac: 43, cat: "Respiratory" },
  { name: "Iron Folic Acid", fac: 38, cat: "MCH" },
  { name: "ORS Sachet", fac: 33, cat: "ORS" },
];

export const SO_FACILITIES = [
  { n: "PHC Sonitpur", stockout: 48 },
  { n: "Sub-centre Dhubri", stockout: 45 },
  { n: "PHC W Karbi A", stockout: 43 },
  { n: "CHC Hailakandi", stockout: 41 },
  { n: "Sub-centre Darrang", stockout: 39 },
  { n: "PHC Goalpara", stockout: 37 },
  { n: "CHC Chirang", stockout: 35 },
  { n: "PHC Nagaon", stockout: 33 },
  { n: "Sub-centre Barpeta", stockout: 30 },
  { n: "PHC KarbiAnglong", stockout: 28 },
];

export const SO_CATEGORIES = [
  { cat: "Essential Medicines", stockout: 28 },
  { cat: "Vaccines & Biologicals", stockout: 8 },
  { cat: "Reproductive Health", stockout: 22 },
  { cat: "TB / Leprosy", stockout: 14 },
  { cat: "Malaria / Vector Control", stockout: 35 },
  { cat: "Pediatric Medicines", stockout: 19 },
  { cat: "ORS / Zinc / Vit-A", stockout: 25 },
  { cat: "Family Planning", stockout: 31 },
  { cat: "AYUSH / Herbal", stockout: 18 },
  { cat: "Surgical / Consumables", stockout: 11 },
];

export const EXPIRED_PRODUCTS = [
  { name: "Tetracycline Eye Oint.", qty: 450, skus: 8 },
  { name: "Ferrous Sulphate Syrup", qty: 520, skus: 7 },
  { name: "Chloramphenicol Drops", qty: 280, skus: 6 },
  { name: "Streptomycin Inj.", qty: 320, skus: 6 },
  { name: "Rifampicin 150mg", qty: 190, skus: 5 },
  { name: "Quinine Sulphate", qty: 140, skus: 4 },
  { name: "Metformin 500mg", qty: 310, skus: 4 },
  { name: "Amoxicillin 250mg", qty: 260, skus: 3 },
  { name: "Paracetamol 500mg", qty: 180, skus: 3 },
  { name: "ORS Packets", qty: 120, skus: 2 },
].sort((a, b) => b.qty - a.qty);

export const EXPIRED_FACILITIES = [
  { name: "PHC Boko", qty: 380, skus: 9 },
  { name: "CHC Rangia", qty: 340, skus: 7 },
  { name: "DH Dhubri", qty: 310, skus: 8 },
  { name: "PHC Sarthebari", qty: 290, skus: 6 },
  { name: "SDH Mangaldoi", qty: 260, skus: 5 },
  { name: "PHC Howraghat", qty: 240, skus: 6 },
  { name: "CHC Bokajan", qty: 210, skus: 4 },
  { name: "PHC Lakhipur", qty: 185, skus: 5 },
  { name: "SC Barama", qty: 160, skus: 3 },
  { name: "PHC Samaguri", qty: 130, skus: 3 },
].sort((a, b) => b.qty - a.qty);

export const EXPIRED_CATEGORIES = [
  { cat: "Essential Medicines", qty: 620, skus: 12 },
  { cat: "Vaccines & Biologicals", qty: 180, skus: 4 },
  { cat: "Reproductive Health", qty: 340, skus: 7 },
  { cat: "TB / Leprosy", qty: 410, skus: 9 },
  { cat: "Malaria / Vector Control", qty: 290, skus: 6 },
  { cat: "Pediatric Medicines", qty: 150, skus: 3 },
  { cat: "ORS / Zinc / Vit-A", qty: 220, skus: 5 },
  { cat: "Family Planning", qty: 130, skus: 3 },
  { cat: "AYUSH / Herbal", qty: 95, skus: 2 },
  { cat: "Surgical / Consumables", qty: 75, skus: 2 },
].sort((a, b) => b.qty - a.qty);

export const EXPIRED_SKUS = [
  {
    name: "Tetracycline Eye Oint.",
    dist: "W Karbi Anglong",
    qty: 450,
    exp: "Jan 2026",
  },
  {
    name: "Chloramphenicol Drops",
    dist: "Hailakandi",
    qty: 280,
    exp: "Dec 2025",
  },
  { name: "Streptomycin Inj.", dist: "Darrang", qty: 320, exp: "Feb 2026" },
  { name: "Rifampicin 150mg", dist: "Goalpara", qty: 190, exp: "Jan 2026" },
  { name: "Quinine Sulphate", dist: "Dhubri", qty: 140, exp: "Feb 2026" },
  {
    name: "Ferrous Sulphate Syrup",
    dist: "Karbi Anglong",
    qty: 520,
    exp: "Dec 2025",
  },
];

export const SKU_LIST = [
  {
    name: "Oxytocin Injection",
    cat: "MCH",
    expDate: "May 2026",
    facilities: 42,
    qty: 1200,
  },
  {
    name: "Misoprostol 200mcg",
    cat: "MCH",
    expDate: "Apr 2026",
    facilities: 38,
    qty: 850,
  },
  {
    name: "Ampicillin 500mg",
    cat: "Antibiotics",
    expDate: "Jun 2026",
    facilities: 35,
    qty: 600,
  },
  {
    name: "Ringer Lactate 500ml",
    cat: "IV Fluids",
    expDate: "Apr 2026",
    facilities: 31,
    qty: 950,
  },
  {
    name: "Gentamicin Inj.",
    cat: "Antibiotics",
    expDate: "May 2026",
    facilities: 28,
    qty: 420,
  },
  {
    name: "Ergometrine Inj.",
    cat: "MCH",
    expDate: "Jun 2026",
    facilities: 25,
    qty: 380,
  },
  {
    name: "Cotrimoxazole DS",
    cat: "Antibiotics",
    expDate: "Jul 2026",
    facilities: 22,
    qty: 700,
  },
  {
    name: "Vitamin A Solution",
    cat: "Nutrition",
    expDate: "May 2026",
    facilities: 20,
    qty: 310,
  },
  {
    name: "ORS Powder",
    cat: "ORS & Fluids",
    expDate: "Jun 2026",
    facilities: 18,
    qty: 560,
  },
  {
    name: "Chlorhexidine Gel",
    cat: "Antiseptics",
    expDate: "Apr 2026",
    facilities: 16,
    qty: 290,
  },
];

export const ALERT_DATA = {
  critical: [
    {
      title: "5 districts have stock-out of essential medicines",
      meta: "Districts: Barpeta, Dhubri, Goalpara, S. Salmara, Hailakandi",
      tip: "Zero stock reported for 3+ consecutive days",
      actions: [
        "Transfer stock from nearby districts with surplus",
        "Place emergency indent via LMIS",
        "Escalate to State Drug Warehouse for immediate dispatch",
      ],
    },
    {
      title: "12 medicines are completely unavailable",
      meta: "Including ORS, Amoxicillin, Paracetamol, Iron-Folic Acid",
      tip: "Zero stock and zero pipeline across multiple facilities",
      actions: [
        "Identify alternate supply sources from adjoining districts",
        "Initiate emergency local purchase as per guidelines",
        "Notify State Programme Officer immediately",
      ],
    },
    {
      title: "6 facilities reported repeated stock-outs",
      meta: "PHC Boko, CHC Rangia, PHC Howraghat, SDH Mangaldoi, PHC Lakhipur, SC Barama",
      tip: "Chronic stock-out: 3+ episodes in last 90 days",
      actions: [
        "Review indent patterns and consumption data",
        "Increase buffer stock allocation for these facilities",
        "Schedule supply chain review meeting with facility in-charges",
      ],
    },
    {
      title: "Zero stock + zero pipeline for 8 critical drugs",
      meta: "Cotrimoxazole, Metronidazole, Albendazole, Zinc tablets, and 4 others",
      tip: "No active procurement orders exist for these items",
      actions: [
        "Place emergency indent for all 8 drugs",
        "Contact State Drug Warehouse for available stock",
        "Arrange inter-district transfer as interim measure",
      ],
    },
  ],
  warning: [
    {
      title: "18 medicines have low stock (< 15 days)",
      meta: "Across 14 districts - risk of stock-out within 2 weeks",
      tip: "Current stock will deplete in under 15 days at current consumption rate",
      actions: [
        "Expedite pending supply orders for these medicines",
        "Place fresh indents before buffer depletion",
        "Monitor daily consumption and adjust distribution",
      ],
    },
    {
      title: "7 deliveries delayed more than 7 days",
      meta: "Suppliers: NHM warehouse (3), State depot (2), Direct vendor (2)",
      tip: "Expected delivery dates exceeded by 7+ days",
      actions: [
        "Follow up with suppliers and logistics partners",
        "Arrange alternate transport if road access is disrupted",
        "Escalate to procurement cell for vendor compliance action",
      ],
    },
    {
      title: "Paracetamol demand increased 40% in 3 districts",
      meta: "Kamrup, Nagaon, Dibrugarh - possible seasonal surge",
      tip: "Sudden consumption spike detected vs 30-day average",
      actions: [
        "Verify if surge is linked to disease outbreak or seasonal demand",
        "Redistribute stock from low-consumption districts",
        "Increase next indent quantity for affected districts",
      ],
    },
    {
      title: "Vaccine cold chain breach reported at 2 facilities",
      meta: "PHC Sarthebari, CHC Bokajan - temperature excursion logged",
      tip: "Cold chain temperature exceeded 8C for > 2 hours",
      actions: [
        "Quarantine affected vaccine batches immediately",
        "Dispatch replacement stock from nearest cold chain point",
        "Arrange cold chain equipment inspection and repair",
      ],
    },
  ],
  operational: [
    {
      title: "32 facilities have not updated stock data",
      meta: "Last update > 7 days ago - data accuracy at risk",
      tip: "Non-reporting facilities may mask actual stock-outs",
      actions: [
        "Send automated reminders to facility in-charges",
        "Escalate non-reporting to District Programme Manager",
        "Schedule supportive supervision visit",
      ],
    },
    {
      title: "12,000 medicine units expiring within 90 days",
      meta: "Across 8 districts - 50 SKUs affected",
      tip: "Near-expiry stock requires immediate redistribution or consumption",
      actions: [
        "Redistribute near-expiry stock to high-consumption facilities",
        "Prioritize dispensing of near-expiry batches (FEFO)",
        "Initiate return-to-vendor process for eligible items",
      ],
    },
    {
      title: "Monthly indent submission pending for 9 districts",
      meta: "Deadline: 20th of current month - 5 days remaining",
      tip: "Late indents may delay next supply cycle",
      actions: [
        "Send reminder notifications to district pharmacists",
        "Provide indent preparation support if needed",
        "Escalate to DPMU if deadline is missed",
      ],
    },
  ],
};

export const AI_DEMAND_TABLE = [
  {
    id: 1,
    medicine: "ORS Packets",
    stock: "45,200",
    consumption: "38,500",
    forecast: "48,125",
    change: "+25%",
    changeColor: "var(--red)",
    status: "critical",
    statusLabel: "Stockout Risk",
    procurement: "Order 50,000 units",
  },
  {
    id: 2,
    medicine: "Paracetamol 500mg",
    stock: "1,20,000",
    consumption: "95,000",
    forecast: "1,04,500",
    change: "+10%",
    changeColor: "var(--amber)",
    status: "warning",
    statusLabel: "Low Stock",
    procurement: "Order 80,000 units",
  },
  {
    id: 3,
    medicine: "Zinc Tablets",
    stock: "18,400",
    consumption: "22,000",
    forecast: "27,500",
    change: "+25%",
    changeColor: "var(--red)",
    status: "critical",
    statusLabel: "Stockout Risk",
    procurement: "Emergency order 30,000",
  },
  {
    id: 4,
    medicine: "Iron-Folic Acid",
    stock: "62,000",
    consumption: "48,000",
    forecast: "55,200",
    change: "+15%",
    changeColor: "var(--amber)",
    status: "warning",
    statusLabel: "Low Stock",
    procurement: "Order 45,000 units",
  },
  {
    id: 5,
    medicine: "Amoxicillin 250mg",
    stock: "85,600",
    consumption: "72,000",
    forecast: "79,200",
    change: "+10%",
    changeColor: "var(--amber)",
    status: "warning",
    statusLabel: "Low Stock",
    procurement: "Order 60,000 units",
  },
  {
    id: 6,
    medicine: "Cotrimoxazole",
    stock: "34,800",
    consumption: "28,000",
    forecast: "29,400",
    change: "+5%",
    changeColor: "var(--teal)",
    status: "ok",
    statusLabel: "Adequate",
    procurement: "No action needed",
    procMuted: true,
  },
  {
    id: 7,
    medicine: "Albendazole 400mg",
    stock: "52,000",
    consumption: "41,000",
    forecast: "42,230",
    change: "+3%",
    changeColor: "var(--teal)",
    status: "ok",
    statusLabel: "Adequate",
    procurement: "No action needed",
    procMuted: true,
  },
  {
    id: 8,
    medicine: "BCG Vaccine",
    stock: "14,200",
    consumption: "12,500",
    forecast: "15,000",
    change: "+20%",
    changeColor: "var(--red)",
    status: "critical",
    statusLabel: "Stockout Risk",
    procurement: "Order 18,000 doses",
  },
  {
    id: 9,
    medicine: "Pentavalent Vaccine",
    stock: "28,000",
    consumption: "24,000",
    forecast: "26,400",
    change: "+10%",
    changeColor: "var(--amber)",
    status: "warning",
    statusLabel: "Low Stock",
    procurement: "Order 22,000 doses",
  },
  {
    id: 10,
    medicine: "Measles-Rubella Vaccine",
    stock: "19,500",
    consumption: "16,800",
    forecast: "18,480",
    change: "+10%",
    changeColor: "var(--amber)",
    status: "warning",
    statusLabel: "Low Stock",
    procurement: "Order 15,000 doses",
  },
  {
    id: 11,
    medicine: "OPV Vaccine",
    stock: "42,000",
    consumption: "35,000",
    forecast: "36,050",
    change: "+3%",
    changeColor: "var(--teal)",
    status: "ok",
    statusLabel: "Adequate",
    procurement: "No action needed",
    procMuted: true,
  },
  {
    id: 12,
    medicine: "Metformin 500mg",
    stock: "38,000",
    consumption: "32,500",
    forecast: "35,750",
    change: "+10%",
    changeColor: "var(--purple)",
    status: "low",
    statusLabel: "Monitor",
    procurement: "Plan order 25,000",
  },
];

export const AI_INSIGHTS = [
  {
    icon: "\u{1F30A}",
    title: "ORS Demand Surge Expected",
    desc: "ORS demand expected to increase by 25% during monsoon season (Jun-Sep). Historical data from 2023-2025 shows consistent diarrhoeal disease spikes.",
    tag: "high",
    tagLabel: "High Impact",
  },
  {
    icon: "\u{1F321}\uFE0F",
    title: "Paracetamol Consumption Rising",
    desc: "Paracetamol consumption rising in 5 districts -- Dhubri, Goalpara, Darrang, Hailakandi, and Karimganj -- linked to seasonal viral fever trends.",
    tag: "medium",
    tagLabel: "Medium Impact",
  },
  {
    icon: "\u26A0\uFE0F",
    title: "Zinc Tablet Stockout Warning",
    desc: "Zinc tablets may stock-out in 3 districts (Goalpara, Dhubri, Darrang) within 20 days based on current burn rate and pipeline status.",
    tag: "high",
    tagLabel: "High Impact",
  },
  {
    icon: "\u{1F469}\u200D\u2695\uFE0F",
    title: "IFA Demand Spike in Tribal Districts",
    desc: "Iron-Folic Acid demand spike predicted in tribal districts (Karbi Anglong, Dima Hasao, Kokrajhar) due to upcoming ANC drive registrations.",
    tag: "medium",
    tagLabel: "Medium Impact",
  },
  {
    icon: "\u{1F69A}",
    title: "Amoxicillin Supply Lead Time Increasing",
    desc: "Amoxicillin supply lead time increasing from 14 to 21 days. Recommend placing orders 1 week early to avoid service disruption.",
    tag: "medium",
    tagLabel: "Medium Impact",
  },
  {
    icon: "\u2744\uFE0F",
    title: "Cold Chain Capacity Alert",
    desc: "Vaccine cold chain capacity at 92% utilization across state. Plan for expansion in 4 districts approaching full capacity before immunization drives.",
    tag: "info",
    tagLabel: "Informational",
  },
];

export const AI_ACTIONS = [
  {
    priority: "urgent",
    priorityLabel: "Urgent",
    title: "Transfer ORS Stock to Goalpara",
    detail:
      "Goalpara district has only 12 days of ORS stock remaining. Transfer 8,000 units from Kamrup Metropolitan (surplus: 15,000 units) to prevent stockout before monsoon.",
    btnLabel: "Initiate Transfer",
  },
  {
    priority: "urgent",
    priorityLabel: "Urgent",
    title: "Emergency Zinc Order for 3 Districts",
    detail:
      "Place emergency procurement of 30,000 Zinc tablets for Goalpara, Dhubri, and Darrang. Current stock will deplete in 18-22 days at projected consumption.",
    btnLabel: "Place Order",
  },
  {
    priority: "high",
    priorityLabel: "High",
    title: "Pre-position IFA in Tribal Districts",
    detail:
      "Distribute 45,000 IFA tablets to Karbi Anglong, Dima Hasao, and Kokrajhar ahead of ANC drive starting April 1. Lead time: 10 days.",
    btnLabel: "Schedule Distribution",
  },
  {
    priority: "medium",
    priorityLabel: "Medium",
    title: "Advance Amoxicillin Procurement",
    detail:
      "Place next Amoxicillin order by March 20 instead of March 28 to account for extended supplier lead time. Recommended quantity: 60,000 units.",
    btnLabel: "Create PO",
  },
];

export const AI_FORECAST_DATA = {
  historicalLabels: [
    "Jan 23",
    "Feb 23",
    "Mar 23",
    "Apr 23",
    "May 23",
    "Jun 23",
    "Jul 23",
    "Aug 23",
    "Sep 23",
    "Oct 23",
    "Nov 23",
    "Dec 23",
    "Jan 24",
    "Feb 24",
    "Mar 24",
    "Apr 24",
    "May 24",
    "Jun 24",
    "Jul 24",
    "Aug 24",
    "Sep 24",
    "Oct 24",
    "Nov 24",
    "Dec 24",
    "Jan 25",
    "Feb 25",
    "Mar 25",
    "Apr 25",
    "May 25",
    "Jun 25",
    "Jul 25",
    "Aug 25",
    "Sep 25",
    "Oct 25",
    "Nov 25",
    "Dec 25",
    "Jan 26",
    "Feb 26",
    "Mar 26",
  ],
  forecastLabels: ["Apr 26", "May 26", "Jun 26"],
  historicalData: [
    28000, 26500, 30000, 33000, 36000, 45000, 52000, 54000, 48000, 35000, 29000,
    27000, 30000, 28000, 32000, 35500, 38000, 48000, 55000, 57000, 50000, 37000,
    31000, 29000, 32000, 30000, 34000, 37000, 40000, 50000, 57000, 59000, 52000,
    39000, 33000, 30500, 34000, 32000, 38500,
  ],
  forecastData: [40000, 44000, 54000],
};

export const SEASONALITY_DATA = {
  months: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  avgMonthly: [
    Math.round((28000 + 30000 + 32000) / 3),
    Math.round((26500 + 28000 + 30000) / 3),
    Math.round((30000 + 32000 + 34000) / 3),
    Math.round((33000 + 35500 + 37000) / 3),
    Math.round((36000 + 38000 + 40000) / 3),
    Math.round((45000 + 48000 + 50000) / 3),
    Math.round((52000 + 55000 + 57000) / 3),
    Math.round((54000 + 57000 + 59000) / 3),
    Math.round((48000 + 50000 + 52000) / 3),
    Math.round((35000 + 37000 + 39000) / 3),
    Math.round((29000 + 31000 + 33000) / 3),
    Math.round((27000 + 29000 + 30500) / 3),
  ],
};

/* ─── Tab 4: District-wise Expired (Qty vs Value) ─────────── */
export const EXPIRED_DISTRICT_DATA = [
  { n: "W Karbi A", qty: 2100, value: 485000 },
  { n: "Hailakandi", qty: 1800, value: 415000 },
  { n: "Darrang", qty: 1500, value: 345000 },
  { n: "Dhubri", qty: 1600, value: 368000 },
  { n: "Karbi A", qty: 1700, value: 391000 },
  { n: "Dima Hasao", qty: 1200, value: 276000 },
  { n: "S Salmara", qty: 1400, value: 322000 },
  { n: "Chirang", qty: 950, value: 218000 },
  { n: "Goalpara", qty: 850, value: 195000 },
  { n: "Barpeta", qty: 800, value: 184000 },
];

/* ─── Tab 4: Facility-wise Expired (Qty vs Value) ─────────── */
export const EXPIRED_FACILITY_DATA = [
  { name: "PHC Boko", qty: 580, value: 133000 },
  { name: "CHC Rangia", qty: 540, value: 124000 },
  { name: "DH Dhubri", qty: 510, value: 117000 },
  { name: "PHC Sarthebari", qty: 490, value: 113000 },
  { name: "SDH Mangaldoi", qty: 460, value: 106000 },
  { name: "PHC Howraghat", qty: 440, value: 101000 },
  { name: "CHC Bokajan", qty: 410, value: 94000 },
  { name: "PHC Lakhipur", qty: 385, value: 88000 },
  { name: "SC Barama", qty: 360, value: 83000 },
  { name: "PHC Samaguri", qty: 330, value: 76000 },
];

export const EXPIRED_CAT_DATA = [
  { cat: "Essential Medicines", qty: 620, value: 143000 },
  { cat: "Vaccines & Biologicals", qty: 180, value: 41000 },
  { cat: "Reproductive Health", qty: 340, value: 78000 },
  { cat: "TB / Leprosy", qty: 410, value: 94000 },
  { cat: "Malaria / Vector Control", qty: 290, value: 67000 },
  { cat: "Pediatric Medicines", qty: 150, value: 35000 },
  { cat: "ORS / Zinc / Vit-A", qty: 220, value: 51000 },
  { cat: "Family Planning", qty: 130, value: 30000 },
  { cat: "AYUSH / Herbal", qty: 95, value: 22000 },
  { cat: "Surgical / Consumables", qty: 75, value: 17000 },
];

export const EXPIRED_PROD_DATA = [
  { name: "Ferrous Sulphate Syrup", qty: 520, value: 120000 },
  { name: "Tetracycline Eye Oint.", qty: 450, value: 104000 },
  { name: "Streptomycin Inj.", qty: 320, value: 74000 },
  { name: "Metformin 500mg", qty: 310, value: 71000 },
  { name: "Chloramphenicol Drops", qty: 280, value: 64000 },
  { name: "Amoxicillin 250mg", qty: 260, value: 60000 },
  { name: "Rifampicin 150mg", qty: 190, value: 44000 },
  { name: "Paracetamol 500mg", qty: 180, value: 41000 },
  { name: "Quinine Sulphate", qty: 140, value: 32000 },
  { name: "ORS Packets", qty: 120, value: 28000 },
];

/* ─── Tab 6: Procurement ───────────────────────────────── */
export const PROC_DISTRICT_DATA = [
  { dist: "Kamrup", amc: 2800, stock: 8500, pipeline: 1200 },
  { dist: "Kamrup M", amc: 3500, stock: 12000, pipeline: 2000 },
  { dist: "Dibrugarh", amc: 2200, stock: 5500, pipeline: 800 },
  { dist: "Jorhat", amc: 1800, stock: 6200, pipeline: 500 },
  { dist: "Nagaon", amc: 2600, stock: 4800, pipeline: 1500 },
  { dist: "Sonitpur", amc: 2000, stock: 7800, pipeline: 600 },
  { dist: "Goalpara", amc: 1500, stock: 2200, pipeline: 400 },
  { dist: "Cachar", amc: 1900, stock: 3800, pipeline: 1000 },
  { dist: "Lakhimpur", amc: 1400, stock: 4500, pipeline: 300 },
  { dist: "Dhemaji", amc: 1200, stock: 2000, pipeline: 500 },
  { dist: "Tinsukia", amc: 1800, stock: 5200, pipeline: 700 },
  { dist: "Sibsagar", amc: 1600, stock: 5800, pipeline: 400 },
  { dist: "Golaghat", amc: 1300, stock: 2500, pipeline: 600 },
  { dist: "Darrang", amc: 1700, stock: 2100, pipeline: 800 },
  { dist: "Barpeta", amc: 2100, stock: 3600, pipeline: 1200 },
  { dist: "Nalbari", amc: 1100, stock: 3800, pipeline: 200 },
  { dist: "Hailakandi", amc: 900, stock: 1200, pipeline: 300 },
  { dist: "Karimganj", amc: 1400, stock: 2800, pipeline: 500 },
  { dist: "Dhubri", amc: 2000, stock: 2500, pipeline: 600 },
  { dist: "Kokrajhar", amc: 1300, stock: 4200, pipeline: 400 },
  { dist: "Chirang", amc: 800, stock: 1500, pipeline: 200 },
  { dist: "Baksa", amc: 900, stock: 1800, pipeline: 300 },
  { dist: "Udalguri", amc: 1000, stock: 3200, pipeline: 200 },
  { dist: "Biswanath", amc: 1200, stock: 4000, pipeline: 500 },
  { dist: "Charaideo", amc: 800, stock: 3000, pipeline: 200 },
  { dist: "Hojai", amc: 1100, stock: 2200, pipeline: 400 },
  { dist: "W Karbi A", amc: 700, stock: 800, pipeline: 200 },
  { dist: "Karbi A", amc: 1000, stock: 1500, pipeline: 300 },
  { dist: "Dima Hasao", amc: 600, stock: 1000, pipeline: 150 },
  { dist: "Bajali", amc: 900, stock: 3200, pipeline: 200 },
  { dist: "Tamulpur", amc: 1000, stock: 2400, pipeline: 300 },
  { dist: "Majuli", amc: 700, stock: 2600, pipeline: 100 },
  { dist: "S Salmara", amc: 800, stock: 1100, pipeline: 200 },
];

export const MEDICINES = [
  {
    name: "Paracetamol 500mg",
    cat: "Essential Medicines",
    amc: 8500,
    stock: 18000,
    pipeline: 3000,
  },
  {
    name: "Amoxicillin 250mg",
    cat: "Essential Medicines",
    amc: 6200,
    stock: 10500,
    pipeline: 2500,
  },
  {
    name: "Metformin 500mg",
    cat: "Essential Medicines",
    amc: 5800,
    stock: 12000,
    pipeline: 1800,
  },
  {
    name: "ORS Packets",
    cat: "ORS / Zinc / Vit-A",
    amc: 9200,
    stock: 15000,
    pipeline: 4000,
  },
  {
    name: "Iron Folic Acid",
    cat: "Reproductive Health",
    amc: 7500,
    stock: 11000,
    pipeline: 2000,
  },
  {
    name: "Zinc Dispersible 20mg",
    cat: "ORS / Zinc / Vit-A",
    amc: 4800,
    stock: 6500,
    pipeline: 1500,
  },
  {
    name: "Amlodipine 5mg",
    cat: "Essential Medicines",
    amc: 3200,
    stock: 8500,
    pipeline: 800,
  },
  {
    name: "Cetirizine 10mg",
    cat: "Essential Medicines",
    amc: 2800,
    stock: 4500,
    pipeline: 600,
  },
  {
    name: "Azithromycin 500mg",
    cat: "Essential Medicines",
    amc: 3500,
    stock: 9000,
    pipeline: 1000,
  },
  {
    name: "Chloroquine Phosphate",
    cat: "Malaria / Vector Control",
    amc: 2200,
    stock: 3000,
    pipeline: 500,
  },
  {
    name: "Rifampicin 150mg",
    cat: "TB / Leprosy",
    amc: 1800,
    stock: 2500,
    pipeline: 400,
  },
  {
    name: "BCG Vaccine",
    cat: "Vaccines & Biologicals",
    amc: 4500,
    stock: 14000,
    pipeline: 2000,
  },
  {
    name: "Misoprostol 200mcg",
    cat: "Reproductive Health",
    amc: 1500,
    stock: 2000,
    pipeline: 300,
  },
  {
    name: "Albendazole 400mg",
    cat: "Pediatric Medicines",
    amc: 3800,
    stock: 8000,
    pipeline: 1500,
  },
  {
    name: "Cotrimoxazole Syrup",
    cat: "Pediatric Medicines",
    amc: 2500,
    stock: 3500,
    pipeline: 600,
  },
];
